/** The Work week of a new board, and what "Reset" returns to: Monday - Friday. */
export const DEFAULT_WORKDAYS: readonly number[] = [1, 2, 3, 4, 5];

export const sameDays = (a: readonly number[], b: readonly number[]): boolean =>
  a.length === b.length && a.every((day, index) => day === b[index]);
